// Clasificación de movimientos bancarios. Este archivo es idéntico en src/ y functions/.
// Sin imports para poder usarlo en el panel y en las Cloud Functions.

export const CATS_BANCO = {
  tpv: { label: 'Cobros con tarjeta', grupo: 'ingreso' },
  efectivo: { label: 'Ingresos de efectivo', grupo: 'ingreso' },
  recibos: { label: 'Recibos domiciliados de clientes', grupo: 'ingreso' },
  otros_ingresos: { label: 'Otros ingresos', grupo: 'ingreso' },
  personal: { label: 'Personal (nóminas, SS, IRPF)', grupo: 'gasto' },
  alquiler: { label: 'Alquiler', grupo: 'gasto' },
  compras: { label: 'Proveedores y laboratorios', grupo: 'gasto' },
  suministros: { label: 'Luz, agua y teléfono', grupo: 'gasto' },
  servicios: { label: 'Servicios (asesoría, colegio, limpieza…)', grupo: 'gasto' },
  seguros: { label: 'Seguros', grupo: 'gasto' },
  comisiones: { label: 'Comisiones banco y TPV', grupo: 'gasto' },
  otros_gastos: { label: 'Otros gastos', grupo: 'gasto' },
  impuestos: { label: 'Impuestos (IVA, sociedades, aplazamientos)', grupo: 'fuera' },
  prestamos: { label: 'Préstamos y leasing', grupo: 'fuera' },
  socios: { label: 'Pagos a socios', grupo: 'fuera' },
  inversion: { label: 'Inversión (compra clínica, obras, fianzas)', grupo: 'fuera' },
  traspaso: { label: 'Traspasos y préstamos recibidos (no cuentan)', grupo: 'excluido' },
  sin_clasificar: { label: 'Sin clasificar', grupo: 'pendiente' },
};

export const GRUPOS_BANCO = [
  ['ingreso', 'Ingresos'],
  ['gasto', 'Gastos del día a día'],
  ['fuera', 'Impuestos, préstamos, socios e inversión'],
];

const sinAcentos = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '');
export const normConcepto = (s) => sinAcentos(s).toUpperCase().replace(/\s+/g, ' ').trim();
// Clave para agrupar conceptos parecidos (sin números): "ON 27575-717 2008" -> "ON # #"
export const claveConcepto = (s) => normConcepto(s).replace(/\d[\d\-./]*/g, '#').replace(/\s+/g, ' ').trim().slice(0, 80);

// Reglas por defecto, en orden. [regex, categoria, opciones]
const REGLAS = [
  [/^ON \d|ABONO TPV/, 'tpv'],
  [/^C\. \d{6,} \d{4}$|COMISION|MANTENIMIENTO TPV|PLANAMYCOMMERCE|SERV\.TPV|^P\.SERV|CUOTA T\.|COND\.CUOTA TARJETA|DESCUBIERTO|^PR\.(DE|FA)\d|PRECIO ED\. EXTRACTO|BONIF\. MULTIDIVISA|PREC\.FATUR/, 'comisiones'],
  [/^FATIR|^DETIR/, 'recibos'],
  [/INGRESO CAJERO|EFECTIVO/, 'efectivo'],
  [/COMPRA (CLINICA|CENTRO)|PAGO CLIN|ULTIMO PAGO CLIN|TRASPASO (CLINICA|CENTRO)|FIANZA|LIQUIDACION DEUDA|REFORMA|ROTULO/, 'inversion'],
  [/^TRASPASO\b|TRASPASO INTERNO|CONSTIT\. PRESTAMO/, 'traspaso'],
  [/RETIRADA DE CAPIT/, 'socios'],
  [/ALQUILER|MENSUALIDAD ALQUI|ARRENDAMIENTO/, 'alquiler'],
  [/NOMIN|TGSS|SEG\.? ?SOCIAL|CUOTAS DE LA SEG|I\.R\.P\.F|IRPF RETENCIONES|FINIQUIT/, 'personal'],
  [/AEAT|IMPUESTOS|EMBARGO|^EXP\d|APLAZAM/, 'impuestos'],
  [/^PRES\.\d|PRESTAMO|PRESTA$|EQUIPMENT/, 'prestamos'],
  [/IBERDROLA|ELECT\.? ?Y GAS|ENDESA|NATURGY|HOLALUZ|REPSOL LUZ|CANAL DE ISAB|VIVA AQUA|TELEFONICA|TELEFONO|DIGI SPAIN|YELLOW EN|VODAFONE|ORANGE|MOVISTAR|LOWI|MASMOVIL|PEPEPHONE/, 'suministros'],
  [/OCCIDENT|SEG\.LASSER|AMVAC|MAPFRE|\bAXA\b|ALLIANZ|MUTUA|SEG\. RIESGO|SEGURO/, 'seguros'],
  [/IDEXX|GARMOGEN|CENTAURO|HISTOVET|BARBA CARRETER|PECUSAM|GEPORK|NUZOA|GOSBI|DISTRIVET|DISTR\.MAT\.VETERIN|PROYMA|ROYAL CANIN|SAMANIEGO|URANO VET|ECHEVARNE|LETI PHARMA|SANGRE ANIMAL|INUVET|FUJIFILM|ARGAEX|PROD\.MIC|XALAB|FCIA|FARMACIA|ZOETIS|\bMSD\b|BOEHRINGER|ELANCO|VIRBAC|HILL'?S|COVETRUS|VETNOVA|KRKA|CEVA/, 'compras'],
  [/COL\.? ?DE VETERIN|COLEGIO|RENTOKIL|ASESOR|BANKTRACK|PREVENCI|PREVENT|ECOPET|ECO PET|CONSENUR|INCINERACION|OEPM|REGISTRAD|CIRCULO VETERINAR|GESTORIA|SCVET|TANATORIO|WAKYMA|PETCLINIC/, 'servicios'],
  [/MERCADONA|IKEA|LEROY MERLIN|MEDIA MARKT|MCDONALD|MC DONALD|^MCD |VIPS|GOIKO|FOSTER|FNAC|ALDI|CARREF|HIPERCOR|SUPERCOR|MAKRO|ALIEXPRESS|AMAZON|AMZN|KIWOKO|PRIMAPRIX|FERRETERIA|^HIPER |CEDIPSA|RESTAU|COMIDA|LIDL|DIA %|CORREOS/, 'otros_gastos'],
  [/TRANSF\. A SU FAVOR|TRANSFER INMEDIATA|ABONO TRANSFERENCIA|AYUNTAMIENTO/, 'otros_ingresos', { signo: 1 }],
];

// Reglas propias de cada organización (orgs/{org}.reglasBancoExtra: [{ patron, categoria, clinicas?, signo? }]), antes que las generales.
// El panel y las funciones dicen de dónde salen con fuenteReglasExtra(() => lista).
let fuenteExtra = () => [];
const cacheRe = new Map();
export function fuenteReglasExtra(fn) { fuenteExtra = fn; }
function reglasExtra() {
  const l = fuenteExtra() || [];
  return l.filter((r) => r?.patron && r?.categoria).map((r) => {
    if (!cacheRe.has(r.patron)) { let re = null; try { re = new RegExp(r.patron); } catch { re = null; } cacheRe.set(r.patron, re); }
    return [cacheRe.get(r.patron), r.categoria, { clinicas: r.clinicas, signo: r.signo }];
  }).filter((r) => r[0]);
}

export function categoriaAuto(concepto, clinica, importe) {
  const n = normConcepto(concepto);
  for (const [re, cat, op] of [...reglasExtra(), ...REGLAS]) {
    if (op?.clinicas && !op.clinicas.includes(clinica)) continue;
    if (op?.signo && Math.sign(importe) !== op.signo) continue;
    if (re.test(n)) return cat;
  }
  return 'sin_clasificar';
}

export const idRegla = (clinica, clave) => `${clinica}__${clave}`.replace(/\//g, '_').slice(0, 300);

// reglas: { [idRegla]: categoria } (las que fija el usuario en el panel)
export function categoriaMov(m, reglas = {}) {
  return m.categoriaFija || reglas[idRegla(m.clinica, claveConcepto(m.concepto))] || categoriaAuto(m.concepto, m.clinica, m.importe);
}

// Resumen: { cats: {cat: importe}, ingresos, gastos, operativo, fuera, caja, pendientes: {n, importe} }
// Los "sin clasificar" suman en otros ingresos / otros gastos según el signo.
export function resumenBanco(movs, reglas = {}) {
  const cats = {};
  let pendientes = 0, pendImporte = 0;
  for (const m of movs) {
    let c = categoriaMov(m, reglas);
    if (c === 'sin_clasificar') { pendientes++; pendImporte += m.importe; c = m.importe >= 0 ? 'otros_ingresos' : 'otros_gastos'; }
    cats[c] = (cats[c] || 0) + m.importe;
  }
  const suma = (g) => Object.entries(cats).filter(([k]) => CATS_BANCO[k]?.grupo === g).reduce((a, [, v]) => a + v, 0);
  const ingresos = suma('ingreso'), gastos = -suma('gasto'), fuera = -suma('fuera');
  return { cats, ingresos, gastos, operativo: ingresos - gastos, fuera, caja: ingresos - gastos - fuera, pendientes: { n: pendientes, importe: pendImporte } };
}
